import React, { useEffect, useState } from 'react'
import { Dimensions, FlatList, StyleSheet, Text, TextInput, TouchableOpacity, View, Image, PixelRatio } from 'react-native'
import { FREQUENCY_TYPE, STATUS_MODERATION, STATUS_PERIOD } from './constants/constants.stores'
import { Feather, Ionicons } from '@expo/vector-icons'
import theme from '../../../theme'
import styles from './CreateScheduleWeekStyles'
import { LinearGradient } from 'expo-linear-gradient'
import { ScrollView } from 'react-native-gesture-handler'
import { DistributorCardStatustag } from './CreateSchedule'
import { formatearFechaArgentina } from '../customUtils/AppConstants'
import { Activity, Period, Week, Day, Distributor } from './models/CreateScheduleModel'
const { width } = Dimensions.get('window')

export const CreateScheduleWeek = ({
    period,
    updatePeriod,
    distributor_activities,
    isModerator,
    indexWeek,
    indexDay,
    setWeek,
    setIndexDay,
    lockExecutive,
    activities,
    monthly_distributor_activities,
    monthly_activities,
    updateMonthlyDistributorActivities,
    updateMonthlyActivities,
}: {
    period: Period
    updatePeriod: (period: Period) => void
    distributor_activities: Activity[]
    isModerator: boolean
    indexWeek: number
    indexDay: number
    setWeek: (index: number) => void
    setIndexDay: (index: number) => void
    lockExecutive: boolean
    activities: Activity[]
    monthly_distributor_activities: Activity[]
    monthly_activities: Activity[]
    updateMonthlyDistributorActivities: (activities: Activity[]) => void
    updateMonthlyActivities: (activities: Activity[]) => void
}) => {
    const weeks = period.weeks ?? []
    const [isOpen, setIsOpen] = useState(false)

    const toggleDropdown = () => {
        setIsOpen(!isOpen)
    }

    if (weeks.length === 0) {
        return (
            <View style={styles.containerNoSchedule}>
                <Image style={styles.imageNoSchedule} source={require('../../../assets/noScheduleWeek.png')} />
                <Text style={styles.titleNoSchedule}>Ha ocurrido un error al cargar los datos de la semana</Text>
                <Text style={styles.descriptionNoSchedule}>Vuelve a intentarlo más tarde</Text>
            </View>
        )
    }

    let defaultDistributor = { _id: '-1', name: '' }

    let selectedDay = weeks[indexWeek].days[indexDay]

    let selectedDate = new Date(selectedDay.date).toLocaleDateString('es-ES', {
        timeZone: 'UTC',
        weekday: 'long',
        day: 'numeric',
        month: 'long',
        year: 'numeric',
    })

    // Divide la fecha en partes
    const [diaMes, mes, año] = selectedDate.split(' de ') || [] // ["lunes, 21", "octubre 2024"]

    // Asegúrate de que diaMes tenga el formato correcto
    const diaSemana = diaMes?.split(', ')[0]?.trim() || '' // "lunes"
    const numeroDia = diaMes?.split(', ')[1]?.trim() || '' // "21"

    // Capitaliza la primera letra del día
    const primeraParte = `${diaSemana.charAt(0).toUpperCase()}${diaSemana.slice(1)} ${numeroDia} `

    // Mantén la segunda parte en minúsculas
    const segundaParte = `de ${mes.toLowerCase()} ${año.toLowerCase()}`

    let distributors = period.distributors ?? []
    let oldDist = period.weeks[indexWeek].days[indexDay].distributor ?? defaultDistributor

    let dropDownOptions = distributors.filter((d) => oldDist && oldDist._id != d._id).map((d) => d)

    const [openPicker, setOpenPicker] = useState(false)
    const setDistributor = (distributor: Distributor) => {
        let newPeriod = { ...period }
        period.weeks[indexWeek].days[indexDay].distributor = distributor
        if (!distributor) {
            newPeriod.weeks[indexWeek].days[indexDay].monthly_distributor_activities = []
            newPeriod.weeks[indexWeek].days[indexDay].monthly_activities = []
            period.weeks[indexWeek].days[indexDay].status = 4 // si borro vuelve a 3
        } else {
            const allAprobed = validateActivitysStatus()

            let allAnswered = validateActivitysAnswered()
            if (allAnswered) {
                period.weeks[indexWeek].days[indexDay].status = allAprobed ? STATUS_PERIOD.PERIOD_APROBB : STATUS_PERIOD.PENDING_CHANGE_REQUIRED_WEEKS
            }
        }
        period.weeks[indexWeek].days[indexDay].status = getDayStatus(period.weeks[indexWeek].days[indexDay])

        updatePeriod(newPeriod)
        setOpenPicker(false)
        setOpenDistributorPicker(false)
    }

    const validateActivitysStatus = () => {
        let allAprobed = true
        let distributor_activities = period.weeks[indexWeek].days[indexDay].distributor_activities ?? []
        let monthly_distributor_activities = period.weeks[indexWeek].days[indexDay].monthly_distributor_activities ?? []
        let monthly_activities = period.weeks[indexWeek].days[indexDay].monthly_activities ?? []

        if (distributor_activities.length > 0 && distributor_activities.some((a) => a.status != 1)) {
            allAprobed = false
        }

        if (monthly_distributor_activities.length > 0 && monthly_distributor_activities.some((a) => a.status != 1)) {
            allAprobed = false
        }
        if (monthly_activities.length > 0 && monthly_activities.some((a) => a.status != 1)) {
            allAprobed = false
        }

        return allAprobed
    }
    const validateActivitysAnswered = () => {
        let allAnswered = true
        let distributor_activities = period.weeks[indexWeek].days[indexDay].distributor_activities ?? []
        let monthly_distributor_activities = period.weeks[indexWeek].days[indexDay].monthly_distributor_activities ?? []
        let monthly_activities = period.weeks[indexWeek].days[indexDay].monthly_activities ?? []

        if (distributor_activities.length > 0 && distributor_activities.some((a) => a.status == 0)) {
            allAnswered = false
        }

        if (monthly_distributor_activities.length > 0 && monthly_distributor_activities.some((a) => a.status == 0)) {
            allAnswered = false
        }
        if (monthly_activities.length > 0 && monthly_activities.some((a) => a.status == 0)) {
            allAnswered = false
        }

        return allAnswered
    }
    const getFilteredDistributorActivities = () => {
        let dropCards = []
        dropCards = distributor_activities
            .filter(
                (activity: Activity) =>
                    selectedDay.distributor_activities &&
                    !selectedDay.distributor_activities.some((a) => a._id === activity._id) &&
                    activity.days?.includes(selectedDay.day),
            )
            .map((activity: Activity) => activity)

        // console.log('dropCards', dropCards)
        return dropCards
    }

    const dropCards: Activity[] = getFilteredDistributorActivities()
    const [openMonthlyDistActivities, setOpenMonthlyDistActivities] = useState(false)
    const getUseCounter = (act: Activity, id: string) => {
        let i = 0
        act.related_distributors?.forEach((d) => {
            if (d._id === id && d.status != -1) {
                i++
            }
        })
        return i
    }
    const getFilteredMonthlyDistributorActivities = () => {
        let activities = []
        activities = monthly_distributor_activities
            .filter((activity: Activity) => {
                const isNotInSelectedDay =
                    selectedDay.monthly_distributor_activities && !selectedDay.monthly_distributor_activities.some((a) => a._id === activity._id)

                const isInSelectedDay = activity.days?.includes(selectedDay.day)

                const isNotAssignedToMonth = !(
                    activity.frequency === 'month' &&
                    activity.related_distributors &&
                    activity.related_distributors.some((distributor) => distributor._id === oldDist?._id && distributor.status === 1)
                )

                const isNotAssignedToFortnight = !(
                    activity.frequency === 'fortnight' &&
                    activity.related_distributors &&
                    getUseCounter(activity, oldDist?._id) > 2
                )

                const isStatusMinusOne =
                    selectedDay.monthly_distributor_activities &&
                    selectedDay.monthly_distributor_activities.some((a) => a._id === activity._id && a.status === -1)

                if (activity.title == 'Combo cierre de mes') {
                    console.log('filtro')
                    // console.log(
                    //     '1 => ',
                    //     isNotInSelectedDay || isStatusMinusOne,
                    //     ' 2 => ',
                    //     isInSelectedDay,
                    //     ' 3 => ',
                    //     isNotAssignedToMonth,
                    //     ' 4 => ',
                    //     isNotAssignedToFortnight,
                    // )
                    // console.log('act => ', JSON.stringify(activity.related_distributors))
                }

                return (isNotInSelectedDay || isStatusMinusOne) && isInSelectedDay && isNotAssignedToMonth && isNotAssignedToFortnight
            })
            .map((activity: Activity) => {
                let maxUses = null

                switch (activity.frequency) {
                    case FREQUENCY_TYPE.MONTH:
                        maxUses = 1
                        break
                    case FREQUENCY_TYPE.FORTNIGHT:
                        maxUses = 2
                        break
                    case FREQUENCY_TYPE.WEEKLY:
                        maxUses = 4
                        break
                    default:
                        maxUses = null
                }

                const currentUses = getUseCounter(activity, oldDist?._id)

                return {
                    ...activity,
                    availability: maxUses ? ` - ${currentUses}/${maxUses}` : '',
                }
            })
        return activities
    }
    let filterMonthlyDistActs: Activity[] = getFilteredMonthlyDistributorActivities()

    const setMonthlyDistributorActivity = (activity: Activity, add: boolean) => {
        let newPeriod = { ...period }
        let act = { ...activity, status: 1 }

        if (add) {
            let index = period.weeks[indexWeek].days[indexDay].monthly_distributor_activities.findIndex((a) => a._id === activity._id)
            if (index != -1) {
                period.weeks[indexWeek].days[indexDay].monthly_distributor_activities[index] = act
            } else {
                period.weeks[indexWeek].days[indexDay].monthly_distributor_activities.push(act)
            }
        } else {
            period.weeks[indexWeek].days[indexDay].monthly_distributor_activities = period.weeks[indexWeek].days[
                indexDay
            ].monthly_distributor_activities.filter((a) => a._id != activity._id)
        }
        if (activity.frequency) {
            console.log('F')
            let newActs = [...monthly_distributor_activities]
            let index = newActs.findIndex((a) => a._id == activity._id)
            if (newActs[index].count === null) {
                newActs[index].count = add ? 1 : 0
            } else {
                newActs[index].count = add ? (newActs[index].count || 0) + 1 : (newActs[index].count || 0) - 1
            }
            let related: Array<{ _id: string; status: number }> = newActs[index].related_distributors ?? []
            if (add) {
                console.log('Add')
                let index2 = related.findIndex((d) => d._id == selectedDay.distributor?._id)
                if (index2 != -1) {
                    // Si el distribuidor ya está en la lista, actualizar el status a -1
                    related[index2].status = 1
                } else {
                    let l = { _id: selectedDay.distributor?._id, status: 1 }
                    related = [...related, l]
                }
            } else {
                console.log('quit')
                let index2 = related.findIndex((d) => d._id == selectedDay.distributor?._id)
                if (index2 != -1) {
                    // Si el distribuidor ya está en la lista, actualizar el status a -1
                    related[index2].status = -1
                }
            }
            newActs[index].related_distributors = related

            monthly_distributor_activities = newActs
            updateMonthlyDistributorActivities(newActs)
        }
        period.weeks[indexWeek].days[indexDay].status = getDayStatus(period.weeks[indexWeek].days[indexDay])

        updatePeriod(newPeriod)
        setOpenMonthlyDistActivities(false)
    }
    const [openMonthlyActivities, setOpenMonthlyActivities] = useState(false)

    const getFilteredActivities = () => {
        let activities = []
        activities = monthly_activities
            .filter((activity: Activity) => {
                const isNotInSelectedDay = selectedDay.monthly_activities && !selectedDay.monthly_activities.some((a) => a._id === activity._id)

                const isInSelectedDay = activity.days?.includes(selectedDay.day)

                const isNotAssignedToMonth = !(
                    activity.frequency === 'month' &&
                    activity.related_distributors &&
                    activity.related_distributors.some((distributor) => distributor._id === oldDist?._id && distributor.status === 1)
                )

                const isNotAssignedToFortnight = !(
                    activity.frequency === 'fortnight' &&
                    activity.related_distributors &&
                    getUseCounter(activity, oldDist?._id) > 2
                )

                const isStatusMinusOne =
                    selectedDay.monthly_activities && selectedDay.monthly_activities.some((a) => a._id === activity._id && a.status === -1)

                return (isNotInSelectedDay || isStatusMinusOne) && isInSelectedDay && isNotAssignedToMonth && isNotAssignedToFortnight
            })
            .map((activity: Activity) => {
                let maxUses = null

                switch (activity.frequency) {
                    case FREQUENCY_TYPE.MONTH:
                        maxUses = 1
                        break
                    case FREQUENCY_TYPE.FORTNIGHT:
                        maxUses = 2
                        break
                    case FREQUENCY_TYPE.WEEKLY:
                        maxUses = 4
                        break
                    default:
                        maxUses = null
                }

                const currentUses = getUseCounter(activity, oldDist?._id)

                return {
                    ...activity,
                    availability: maxUses ? ` - ${currentUses}/${maxUses}` : '',
                }
            })
        return activities
    }
    let filterMonthlyActs: Activity[] = getFilteredActivities()

    const setDistributorActivity = (activity: Activity, add: boolean) => {
        let newPeriod = { ...period }
        if (add) {
            period.weeks[indexWeek].days[indexDay].distributor_activities.push(activity)
            if (!isModerator) {
                period.weeks[indexWeek].days[indexDay].status = 0
            }
        } else {
            console.log('F3')
            period.weeks[indexWeek].days[indexDay].distributor_activities = period.weeks[indexWeek].days[indexDay].distributor_activities.filter(
                (a) => a._id != activity._id,
            )
            if (period.weeks[indexWeek].days[indexDay].distributor_activities.length === 0) {
                period.weeks[indexWeek].days[indexDay].status = 4
            }
        }

        if (activity.vacation != undefined && activity.vacation && add) {
            period.weeks[indexWeek].days[indexDay].status = 10
            period.weeks[indexWeek].days[indexDay].distributor_activities = []
            period.weeks[indexWeek].days[indexDay].distributor_activities.push(activity)
            period.weeks[indexWeek].days[indexDay].distributor = null
        }
        period.weeks[indexWeek].days[indexDay].status = getDayStatus(period.weeks[indexWeek].days[indexDay])

        updatePeriod(newPeriod)
        setOpenPicker(false)
    }
    const updateDistributorActivity = (activity: Activity, status: number) => {
        let newPeriod = { ...period }
        let act = { ...activity, status: status }
        let index = period.weeks[indexWeek].days[indexDay].distributor_activities.findIndex((a) => a._id === activity._id)
        period.weeks[indexWeek].days[indexDay].distributor_activities[index] = act
        const allAprobed = validateActivitysStatus()

        let allAnswered = validateActivitysAnswered()
        if (allAnswered) {
            period.weeks[indexWeek].days[indexDay].status = allAprobed ? STATUS_PERIOD.PERIOD_APROBB : STATUS_PERIOD.PENDING_CHANGE_REQUIRED_WEEKS
        }
        if (activity.vacation != undefined && activity.vacation) {
            period.weeks[indexWeek].days[indexDay].status = 10
            period.weeks[indexWeek].days[indexDay].distributor_activities = []
        }
        updatePeriod(newPeriod)
        setOpenPicker(false)
    }
    const updateMonthlyActivity = (activity: Activity, status: number) => {
        let newPeriod = { ...period }
        let act = { ...activity, status: status }
        let index = period.weeks[indexWeek].days[indexDay].monthly_activities.findIndex((a) => a._id === activity._id)
        period.weeks[indexWeek].days[indexDay].monthly_activities[index] = act
        const allAprobed = validateActivitysStatus()
        let allAnswered = validateActivitysAnswered()
        if (allAnswered) {
            period.weeks[indexWeek].days[indexDay].status = allAprobed ? STATUS_PERIOD.PERIOD_APROBB : STATUS_PERIOD.PENDING_CHANGE_REQUIRED_WEEKS
        }

        if (activity.vacation != undefined && activity.vacation) {
            if (status == -1) {
                period.weeks[indexWeek].days[indexDay].distributor = null
                period.weeks[indexWeek].days[indexDay].status = 4
            } else {
                period.weeks[indexWeek].days[indexDay].status = 10
            }
            period.weeks[indexWeek].days[indexDay].distributor_activities = []
        }

        let newActs = [...monthly_activities]
        let indexAct = newActs.findIndex((a) => a._id == activity._id)

        let related: Array<{ _id: string; status: number }> = newActs[indexAct].related_distributors ?? []
        let index2 = related.findIndex((d) => d._id == selectedDay.distributor?._id)
        if (index2 != -1) {
            // Si el distribuidor ya está en la lista, actualizar el status a -1
            related[index2].status = -1
        }

        newActs[indexAct].related_distributors = related
        console.log('ad = > ', JSON.stringify(newActs))
        monthly_distributor_activities = newActs
        period.weeks[indexWeek].days[indexDay].status = getDayStatus(period.weeks[indexWeek].days[indexDay])
        updatePeriod(newPeriod)
        setOpenPicker(false)
    }
    const updateMonthlyDistributorActivity = (activity: Activity, status: number) => {
        let newPeriod = { ...period }
        let act = { ...activity, status: status }
        let index = period.weeks[indexWeek].days[indexDay].monthly_distributor_activities.findIndex((a) => a._id === activity._id)
        period.weeks[indexWeek].days[indexDay].monthly_distributor_activities[index] = act
        const allAprobed = validateActivitysStatus()
        let allAnswered = validateActivitysAnswered()
        if (allAnswered) {
            period.weeks[indexWeek].days[indexDay].status = allAprobed ? STATUS_PERIOD.PERIOD_APROBB : STATUS_PERIOD.PENDING_CHANGE_REQUIRED_WEEKS
        }

        if (activity.vacation != undefined && activity.vacation) {
            period.weeks[indexWeek].days[indexDay].status = 10
            period.weeks[indexWeek].days[indexDay].distributor_activities = []
        }

        let newActs = [...monthly_distributor_activities]
        let indexAct = newActs.findIndex((a) => a._id == activity._id)

        let related: Array<{ _id: string; status: number }> = newActs[indexAct].related_distributors ?? []
        let index2 = related.findIndex((d) => d._id == selectedDay.distributor?._id)
        if (index2 != -1) {
            // Si el distribuidor ya está en la lista, actualizar el status a -1
            related[index2].status = -1
        }

        newActs[indexAct].related_distributors = related
        console.log('ad = > ', JSON.stringify(newActs))
        monthly_distributor_activities = newActs
        period.weeks[indexWeek].days[indexDay].status = getDayStatus(period.weeks[indexWeek].days[indexDay])

        updatePeriod(newPeriod)
        setOpenPicker(false)
    }
    useEffect(() => {
        setOpenPicker(false)
        setOpenOtherActivities(false)
        setOpenDistributorPicker(false)
        setOpenMonthlyActivities(false)
        setOpenMonthlyDistActivities(false)
    }, [indexWeek, indexDay])

    const [openOtherActivities, setOpenOtherActivities] = useState(false)

    const setOtherActivity = (activity: Activity, add: boolean) => {
        let newPeriod = { ...period }
        let act = { ...activity, status: 1 }
        if (add) {
            let index = period.weeks[indexWeek].days[indexDay].monthly_activities.findIndex((a) => a._id === activity._id)
            if (index != -1) {
                period.weeks[indexWeek].days[indexDay].monthly_activities[index] = act
            } else {
                period.weeks[indexWeek].days[indexDay].monthly_activities.push(act)
            }
        } else {
            period.weeks[indexWeek].days[indexDay].monthly_activities = period.weeks[indexWeek].days[indexDay].monthly_activities.filter(
                (a) => a._id != activity._id,
            )

            if (period.weeks[indexWeek].days[indexDay].distributor == null) {
                period.weeks[indexWeek].days[indexDay].status = 3
                if (activity && activity.form_id) {
                    period.weeks[indexWeek].days[indexDay].status = 3
                } else {
                    period.weeks[indexWeek].days[indexDay].status = 3
                    // valido que no tenga distribuidor y que no tenga otras actividades con form id
                    if (
                        period.weeks[indexWeek].days[indexDay].distributor == null &&
                        period.weeks[indexWeek].days[indexDay].monthly_activities &&
                        period.weeks[indexWeek].days[indexDay].monthly_activities.length > 0
                    ) {
                        // verifico si tengo alguna actividad con form_id
                        if (period.weeks[indexWeek].days[indexDay].monthly_activities.some((a) => a.form_id)) {
                            period.weeks[indexWeek].days[indexDay].status = 0 // si tengo alguna actividad con form_id paso a 0
                        }
                    }
                }
            }
        }
        if (activity.frequency) {
            let newActs = [...monthly_activities]
            let index = newActs.findIndex((a) => a._id == activity._id)
            if (newActs[index].count === null) {
                newActs[index].count = add ? 1 : 0
            } else {
                newActs[index].count = add ? (newActs[index].count || 0) + 1 : (newActs[index].count || 0) - 1
            }
            updateMonthlyActivities(newActs)
        }

        if (activity.vacation != undefined && activity.vacation && add) {
            period.weeks[indexWeek].days[indexDay].status = 10
            period.weeks[indexWeek].days[indexDay].monthly_activities = []
            period.weeks[indexWeek].days[indexDay].monthly_activities.push(activity)
        } else {
            if (activity && activity.form_id && add) {
                period.weeks[indexWeek].days[indexDay].status = 3
            } else {
                period.weeks[indexWeek].days[indexDay].status = 0
            }
        }
        period.weeks[indexWeek].days[indexDay].status = getDayStatus(period.weeks[indexWeek].days[indexDay])

        updatePeriod(newPeriod)
        setOpenOtherActivities(false)
    }
    const validateBloqued = (week: Week) => {
        let isBloqued = false

        if (week.status == STATUS_PERIOD.PERIOD_APROBB) {
            isBloqued = false
        }
        if (week.days[indexDay].previous_day == true) {
            isBloqued = true
        }
        return isBloqued
    }
    let isBloqued = validateBloqued(weeks[indexWeek])

    const getFreqLabel = (freq: string) => {
        let label = ''
        switch (freq) {
            case 'month':
                label = 'M'
                break
            case 'fortnight':
                label = 'Q'
                break
            case 'weekly':
                label = 'S'
                break
            case 'day':
                label = 'D'
                break
            default:
                label = 'D'
        }
        return label
    }
    const getDayStatus = (day: Day) => {
        //Status 8 por modificacion por parte del gerente
        let status = 3
        let isVacation = day.monthly_activities.some((a) => a.vacation == true && a.status != -1)
        if (isVacation) {
            status = 10
        } else {
            if (day.day != 5) {
                //Dia de semana // && day.monthly_distributor_activities.length > 0
                if (day.distributor != null) {
                    status = isModerator ? 8 : 0
                    // let l = day.monthly_distributor_activities.some((a) => a.status != -1)
                    // //Tiene actividades
                    // if (l) {
                    //     // Tiene al menos 1 actividad en estado diferente a -1
                    //     status = isModerator ? 1 : 0
                    //     console.log('status', status)
                    // } else {
                    //     status = 8
                    // }
                } else {
                    if (day.monthly_activities.length > 0) {
                        let formIndex = day.monthly_activities.findIndex((a) => a.form_id && a.status != -1)

                        if (formIndex != -1) {
                            let formsStatus = day.monthly_activities[formIndex]?.status
                            let formID = formsStatus != -1 ? true : false
                            if (formID) {
                                status = isModerator ? 8 : 0
                            } else {
                                status = isModerator ? 4 : 3
                            }
                        } else {
                            status = isModerator ? 4 : 3
                        }
                    } else {
                        status = isModerator ? 4 : 3
                    }
                }
            } else {
                //Sabado
                if (day.monthly_activities.length > 0) {
                    let l = day.monthly_activities.some((a) => a.status != -1)
                    //Tiene actividades
                    if (l) {
                        // Tiene al menos 1 actividad en estado diferente a -1
                        status = isModerator ? 8 : 0
                    } else {
                        status = 4
                    }
                } else {
                    //No tiene actividades
                    status = 4
                }
            }
        }
        console.log('retorno esto', status)
        return status
    }
    const [openDistributorPicker, setOpenDistributorPicker] = useState(false)

    const fontScale = 1
    const iconSize = 12 * fontScale

    const fechaActual = new Date()
    // const today = new Date('2024-10-05T12:56:46.950Z')
    const fechaArgentina = new Date(fechaActual.setHours(fechaActual.getHours() - 3))

    const fechaCompleta = formatearFechaArgentina(fechaArgentina)

    if (!isModerator) {
        return (
            <View style={styles.container}>
                <ScheduleCalendar
                    week={weeks[indexWeek]}
                    changeWeek={setWeek}
                    currendDayIndex={indexDay}
                    changeDay={setIndexDay}
                    isModerator={isModerator}
                    periodStatus={period.status}
                />

                <View style={[styles.containerRow, styles.marginHorizontal]}>
                    <Text style={[styles.date, { fontWeight: 'bold' }]}>{primeraParte}</Text>
                    <Text style={[styles.date]}>{segundaParte.toLowerCase()}</Text>
                </View>

                {/*<Text style={styles.date}>{selectedDate}</Text>*/}

                {/* <Text style={styles.title}>Elige el distribuidor: </Text> */}
                <View style={styles.spacer}></View>
                <View style={{ opacity: isBloqued || lockExecutive ? 0.7 : 1, pointerEvents: isBloqued || lockExecutive ? 'none' : null }}>
                    {!selectedDay.distributor && selectedDay.day != 5 && selectedDay.status != STATUS_PERIOD.VACATION && (
                        <>
                            <TouchableOpacity
                                style={[styles.input, { marginHorizontal: 12, marginBottom: openDistributorPicker ? 0 : 12 }]}
                                onPress={() => setOpenDistributorPicker(!openDistributorPicker)}
                            >
                                <Text style={styles.subtitle}>Elegir distribuidor</Text>
                                <View style={styles.containerRow}>
                                    {/*<Feather name={'search'} size={22} color={theme.colors.colorPrimary} />*/}
                                    <Feather
                                        name={openDistributorPicker ? 'chevron-up' : 'chevron-down'}
                                        size={22}
                                        color={theme.colors.colorPrimary}
                                    />
                                </View>
                            </TouchableOpacity>
                            {openDistributorPicker && (
                                <View style={[styles.inputDropdownMenuSubsection, styles.marginHorizontal, { marginBottom: 12 }]}>
                                    {dropDownOptions.length > 0 && (
                                        <ScrollView>
                                            <View>
                                                {dropDownOptions.map((distributor) => (
                                                    <TouchableOpacity
                                                        key={distributor._id}
                                                        style={{ marginVertical: 8 }}
                                                        onPress={() => setDistributor(distributor)}
                                                    >
                                                        <Text style={styles.title}>{distributor.name}</Text>
                                                        <Text style={styles.subtitle}>{distributor.address}</Text>
                                                    </TouchableOpacity>
                                                ))}
                                            </View>
                                        </ScrollView>
                                    )}
                                    <View style={styles.spacer2}></View>
                                </View>
                            )}
                        </>
                    )}
                    {selectedDay.day != 5 && oldDist && oldDist.name && selectedDay.status != STATUS_PERIOD.VACATION && (
                        <>
                            <Text style={styles.section}>Actividades en: </Text>
                            <SelectedDistributorCard
                                key={indexWeek + indexDay}
                                distributor={oldDist}
                                deleteDistributor={() => setDistributor(null)}
                                activities={dropCards}
                                setActivity={(a, b) => setDistributorActivity(a, b)}
                                selectedAct={selectedDay.activities}
                                canDelete={lockExecutive ? false : true}
                            />
                        </>
                    )}
                </View>

                {/* <Text style={styles.title}>Agregar otras actividades: </Text> */}

                <View style={{ opacity: isBloqued || lockExecutive ? 0.7 : 1, pointerEvents: isBloqued || lockExecutive ? 'none' : null }}>
                    {selectedDay.day != 5 && oldDist && oldDist.name && selectedDay.status != STATUS_PERIOD.VACATION && (
                        <>
                            <View>
                                {/* {selectedDay.monthly_distributor_activities.length > 0 && (
                                    <View style={styles.containerRow}>
                                        {selectedDay.monthly_distributor_activities.map((act) => (
                                            <View
                                                key={act._id}
                                                style={[styles.containerRow, { width: '100%', marginVertical: 6, justifyContent: 'space-between' }]}
                                            >
                                                <Text style={[styles.subtitle, { maxWidth: '80%' }]}>{act.title}</Text>
                                                <View style={[styles.label, { marginRight: 12 }]}>
                                                    <Ionicons name={'calendar'} size={12} color={'white'} style={styles.paddingRight} />
                                                    <Text style={styles.frequency}>{getFreqLabel(act.frequency ?? '')}</Text>
                                                </View>
                                            </View>
                                        ))}
                                    </View>
                                )} */}
                            </View>
                            {!lockExecutive && (
                                <TouchableOpacity style={[styles.input, { marginHorizontal: 12 }]} onPress={() => setOpenPicker(!openPicker)}>
                                    <Text style={styles.subtitle}>Elegir actividades</Text>
                                    <View style={styles.containerRow}>
                                        <Feather
                                            name={openOtherActivities ? 'chevron-up' : 'chevron-down'}
                                            size={22}
                                            color={theme.colors.colorPrimary}
                                        />
                                    </View>
                                </TouchableOpacity>
                            )}
                            {openPicker && (
                                <View>
                                    {filterMonthlyDistActs.length > 0 && (
                                        <View style={styles.inputDropdownMenuSubsection}>
                                            {filterMonthlyDistActs.map((act) => (
                                                <TouchableOpacity
                                                    key={act._id}
                                                    style={{ marginVertical: 8 }}
                                                    onPress={() => {
                                                        setMonthlyDistributorActivity(act, true)
                                                        setOpenPicker(false)
                                                    }}
                                                >
                                                    <Text style={styles.subtitle}>{act.title}</Text>
                                                    <Text style={styles.subtitle}>{act.status}</Text>
                                                </TouchableOpacity>
                                            ))}
                                        </View>
                                    )}
                                </View>
                            )}
                            {selectedDay.monthly_distributor_activities.length > 0 && (
                                <>
                                    {weeks[indexWeek].days[indexDay].monthly_distributor_activities
                                        .filter((a) => a.status != -1)
                                        .map((activity) => (
                                            <View
                                                key={activity._id}
                                                style={[
                                                    styles.containerRow,
                                                    styles.optionSelected,
                                                    {
                                                        marginTop: 8,
                                                        marginHorizontal: 12,
                                                        marginVertical: 2,
                                                        paddingVertical: 8,
                                                        justifyContent: 'space-between',
                                                    },
                                                ]}
                                            >
                                                {period.status !== STATUS_PERIOD.PENDING_APPROBB_WEEKS && (
                                                    <View style={[styles.containerRow, { flex: 10 }]}>
                                                        <Text style={[styles.option, { flex: 2, marginLeft: 12 }]}>{activity.title}</Text>
                                                        <View style={[{ flexDirection: 'row', justifyContent: 'space-between' }]}>
                                                            <View style={[styles.labelBis, { marginRight: 12 }]}>
                                                                <Ionicons
                                                                    name={'calendar'}
                                                                    size={iconSize}
                                                                    color={theme.colors.colorSecondary}
                                                                    style={styles.paddingRight}
                                                                />
                                                                <Text style={styles.frequencyBis}>{getFreqLabel(activity.frequency ?? '')}</Text>
                                                                {/*<Text style={styles.frequencyBis}>D</Text>*/}
                                                            </View>
                                                            {!lockExecutive && (
                                                                <TouchableOpacity
                                                                    style={styles.marginLeft}
                                                                    onPress={() => updateMonthlyDistributorActivity(activity, -1)}
                                                                >
                                                                    <Ionicons
                                                                        style={styles.marginRight}
                                                                        name={'trash-outline'}
                                                                        size={24}
                                                                        color={theme.colors.error}
                                                                    />
                                                                </TouchableOpacity>
                                                            )}
                                                        </View>
                                                    </View>
                                                )}
                                            </View>
                                        ))}
                                </>
                            )}
                        </>
                    )}
                    {oldDist && oldDist.name && <View style={styles.spacer2}></View>}
                    {oldDist && oldDist.name && selectedDay.monthly_activities.length > 0 && <View style={styles.divider}></View>}
                    <View style={styles.spacer2}></View>
                    {selectedDay.monthly_activities.length > 0 && (
                        <View>
                            <Text style={styles.section}>{lockExecutive ? 'Otras actividades:' : 'Planificar otras actividades:'}</Text>
                            <View style={styles.spacerMin}></View>
                            {!lockExecutive && (
                                <Text style={styles.subSection}>
                                    {lockExecutive ? '' : 'Selecciona las actividades no relacionadas con el distribuidor'}
                                </Text>
                            )}
                            {/* {selectedDay.monthly_activities.length > 0 && (
                            <View>
                                {selectedDay.monthly_activities.map((act) => (
                                    <View
                                        key={act._id}
                                        style={[styles.containerRow, { flex: 1, marginVertical: 6, justifyContent: 'space-between' }]}
                                    >
                                        <View style={[styles.containerRow, { flex: 9 }]}>
                                            <Text style={[styles.subtitle]}>{act.title}</Text>
                                        </View>
                                        <View style={{ flexDirection: 'row', marginRight: 12 }}>
                                            <View>
                                                <View style={[styles.label, { flex: 1, marginRight: 12 }]}>
                                                    <Ionicons name={'calendar'} size={12} color={'white'} style={styles.paddingRight} />
                                                    <Text style={styles.frequency}>{getFreqLabel(act.frequency ?? '')}</Text>
                                                </View>
                                            </View>
                                            {selectedDay.status == 10 && (
                                                <TouchableOpacity style={styles.marginRight}>
                                                    <Ionicons name={'trash-outline'} size={24} color={theme.colors.error} />
                                                </TouchableOpacity>
                                            )}
                                        </View>
                                    </View>
                                ))}
                            </View>
                        )} */}
                        </View>
                    )}
                    {selectedDay.status != 10 && !lockExecutive && (
                        <TouchableOpacity
                            style={[styles.input, { marginHorizontal: 12 }]}
                            onPress={() => setOpenOtherActivities(!openOtherActivities)}
                        >
                            <Text style={styles.subtitle}>Elegir otras actividades</Text>
                            <View style={styles.containerRow}>
                                {/*<Feather name={'search'} size={22} color={theme.colors.colorPrimary} />*/}
                                <Feather name={openOtherActivities ? 'chevron-up' : 'chevron-down'} size={22} color={theme.colors.colorPrimary} />
                            </View>
                        </TouchableOpacity>
                    )}
                    {openOtherActivities && (
                        <View>
                            {filterMonthlyActs.length > 0 && (
                                <View style={styles.inputDropdownMenuSubsection}>
                                    {filterMonthlyActs.map((act, i) => (
                                        <TouchableOpacity
                                            key={act._id + i}
                                            style={{ marginVertical: 8 }}
                                            onPress={() => {
                                                setOtherActivity(act, true)
                                                setOpenOtherActivities(false)
                                            }}
                                            disabled={selectedDay.status == STATUS_PERIOD.VACATION}
                                        >
                                            <Text style={styles.subtitle}>{act.title}</Text>
                                        </TouchableOpacity>
                                    ))}
                                </View>
                            )}
                        </View>
                    )}

                    {selectedDay.monthly_activities.length > 0 && (
                        <>
                            {selectedDay.monthly_activities
                                .filter((a) => a.status != -1)
                                .map((activity) => (
                                    <View
                                        key={activity._id}
                                        style={[
                                            styles.containerRow,
                                            styles.optionSelected,
                                            { marginTop: 8, marginHorizontal: 12, justifyContent: 'space-between' },
                                        ]}
                                    >
                                        <View style={[styles.containerRow, { flex: 10 }]}>
                                            <Text style={[styles.option, { flex: 2 }]}>{activity.title}</Text>
                                        </View>
                                        <View style={[styles.labelBis, { flex: 1.5, marginRight: 12 }]}>
                                            <Ionicons
                                                name={'calendar'}
                                                size={iconSize}
                                                color={theme.colors.colorSecondary}
                                                style={styles.paddingRight}
                                            />
                                            <Text style={styles.frequencyBis}>{getFreqLabel(activity.frequency ?? '')}</Text>
                                        </View>
                                        {!lockExecutive && (
                                            <TouchableOpacity style={styles.marginRight} onPress={() => updateMonthlyActivity(activity, -1)}>
                                                <Ionicons name={'trash-outline'} size={24} color={theme.colors.error} />
                                            </TouchableOpacity>
                                        )}
                                    </View>
                                ))}
                        </>
                    )}
                </View>
                <View style={styles.spacer3}></View>
            </View>
        )
    } else {
        return (
            <View style={styles.container}>
                <ScheduleCalendar
                    week={weeks[indexWeek]}
                    changeWeek={setWeek}
                    currendDayIndex={indexDay}
                    changeDay={setIndexDay}
                    isModerator={isModerator}
                    periodStatus={period.status}
                />
                <View style={[styles.containerRow, styles.marginHorizontal]}>
                    <Text style={[styles.date, { fontWeight: 'bold' }]}>{primeraParte}</Text>
                    <Text style={[styles.date]}>{segundaParte.toLowerCase()}</Text>
                </View>

                {/*<Text style={styles.date}>{selectedDate}</Text>*/}

                {selectedDay.distributor_activities.length > 0 && selectedDay.status != STATUS_PERIOD.VACATION && (
                    <View>
                        <View style={styles.spacer}></View>

                        <Text style={styles.section}>Valida las actividades semanales: </Text>
                        <View style={styles.spacerMin}></View>
                        <Text style={styles.subSection}>Revisa las actividades que el ejecutivo eligió para el distribuidor</Text>
                    </View>
                )}
                <View style={{ opacity: isBloqued ? 0.7 : 1, pointerEvents: isBloqued ? 'none' : null }}>
                    {!selectedDay.distributor && selectedDay.day != 5 && selectedDay.status != STATUS_PERIOD.VACATION && (
                        <>
                            <TouchableOpacity
                                style={[styles.input, { marginHorizontal: 12, marginBottom: openDistributorPicker ? 0 : 12 }]}
                                onPress={() => setOpenDistributorPicker(!openDistributorPicker)}
                            >
                                <Text style={styles.subtitle}>Elegir distribuidor</Text>
                                <View style={styles.containerRow}>
                                    {/*<Feather name={'search'} size={22} color={theme.colors.colorPrimary} />*/}
                                    <Feather
                                        name={openDistributorPicker ? 'chevron-up' : 'chevron-down'}
                                        size={22}
                                        color={theme.colors.colorPrimary}
                                    />
                                </View>
                            </TouchableOpacity>
                            {openDistributorPicker && (
                                <View style={[styles.inputDropdownMenuSubsection, styles.marginHorizontal, { marginBottom: 12 }]}>
                                    {dropDownOptions.length > 0 && (
                                        <ScrollView>
                                            <View>
                                                {dropDownOptions.map((distributor) => (
                                                    <TouchableOpacity
                                                        key={distributor._id}
                                                        style={{ marginVertical: 8 }}
                                                        onPress={() => setDistributor(distributor)}
                                                    >
                                                        <Text style={styles.title}>{distributor.name}</Text>
                                                        <Text style={styles.subtitle}>{distributor.address}</Text>
                                                    </TouchableOpacity>
                                                ))}
                                            </View>
                                        </ScrollView>
                                    )}
                                    <View style={styles.spacer2}></View>
                                </View>
                            )}
                        </>
                    )}
                    {selectedDay.day != 5 && selectedDay.distributor && selectedDay.status != STATUS_PERIOD.VACATION && (
                        <>
                            <View style={styles.spacer}></View>
                            <Text style={styles.section}>Actividades en distribuidor: </Text>
                            <View style={styles.spacerMin}></View>
                            <Text style={styles.subSection}>
                                Revisa las actividades que se le asignaron al distribuidor. Puedes eliminar o modificar lo que consideres necesario
                                para ajustar la planificación del día.
                            </Text>
                            <View style={styles.spacer}></View>

                            <SelectedDistributorCard
                                distributor={oldDist}
                                deleteDistributor={() => setDistributor(null)}
                                activities={[]}
                                setActivity={(a, b) => {}}
                                selectedAct={[]}
                                canDelete={true}
                            />

                            {selectedDay.status != STATUS_PERIOD.VACATION &&
                                selectedDay.monthly_distributor_activities
                                    .filter((a) => a.status != -1)
                                    .map((activity) => (
                                        <View style={[styles.containerRow, { flex: 1, marginBottom: 8 }]} key={activity._id}>
                                            <View
                                                style={[styles.containerRow, { width: '100%', marginVertical: 6, justifyContent: 'space-between' }]}
                                            >
                                                <Text style={[styles.subtitle, { flex: 1 }]}>{activity.title}</Text>
                                                <View style={[styles.label, { marginRight: 12 }]}>
                                                    <Ionicons name={'calendar'} size={iconSize} color={'white'} style={styles.paddingRight} />
                                                    <Text style={styles.frequency}>{getFreqLabel(activity.frequency ?? '')}</Text>
                                                </View>
                                                <View style={{ flexDirection: 'row' }}>
                                                    <TouchableOpacity
                                                        style={[{ flexDirection: 'row', marginRight: 12 }]}
                                                        onPress={() => updateMonthlyDistributorActivity(activity, -1)}
                                                    >
                                                        <Ionicons
                                                            name={activity.status === -1 ? 'trash' : 'trash-outline'}
                                                            size={26}
                                                            color={theme.colors.colorDisapproved}
                                                        />
                                                    </TouchableOpacity>
                                                </View>
                                            </View>
                                        </View>
                                    ))}
                            <>
                                {/*<View style={styles.spacer}></View>
                                <View style={styles.spacer}></View>
                                <Text style={styles.section}>Valida las actividades semanales relacionadas al distribuidor: </Text>
                                <View style={styles.spacer}></View>*/}

                                <TouchableOpacity
                                    style={[styles.input, { marginTop: 0, marginHorizontal: 12 }]}
                                    onPress={() => setOpenMonthlyDistActivities(!openMonthlyDistActivities)}
                                >
                                    <Text style={styles.subtitle}>Elegir actividades mensuales</Text>
                                    <View style={styles.containerRow}>
                                        <Feather
                                            name={openMonthlyDistActivities ? 'chevron-up' : 'chevron-down'}
                                            size={22}
                                            color={theme.colors.colorPrimary}
                                        />
                                    </View>
                                </TouchableOpacity>

                                {openMonthlyDistActivities && (
                                    <View>
                                        {filterMonthlyDistActs.length > 0 && (
                                            <View style={[styles.inputDropdownMenuSubsection, styles.marginHorizontal]}>
                                                {filterMonthlyDistActs.map((act) => (
                                                    <TouchableOpacity
                                                        key={act._id}
                                                        style={{ marginVertical: 8 }}
                                                        onPress={() => {
                                                            setMonthlyDistributorActivity(act, true)
                                                            setOpenMonthlyDistActivities(false)
                                                        }}
                                                    >
                                                        <Text style={styles.option}>
                                                            {act.title}
                                                            {act.availability}
                                                        </Text>
                                                    </TouchableOpacity>
                                                ))}
                                            </View>
                                        )}
                                    </View>
                                )}
                            </>
                        </>
                    )}

                    {/* {selectedDay.status != STATUS_PERIOD.VACATION && (
                        <>
                            <TouchableOpacity style={[styles.input, { marginHorizontal: 12 }]} onPress={() => setOpenPicker(!openPicker)}>
                                <Text style={styles.subtitle}>Elegir más actividades</Text>
                                <View style={styles.containerRow}>
                                    <Feather name={openOtherActivities ? 'chevron-up' : 'chevron-down'} size={22} color={theme.colors.colorPrimary} />
                                </View>
                            </TouchableOpacity>

                            {openPicker && (
                                <View>
                                    {dropCards.length > 0 && (
                                        <View style={styles.inputDropdownMenuSubsection}>
                                            {dropCards.map((act) => (
                                                <TouchableOpacity
                                                    key={act._id}
                                                    style={{ marginVertical: 8 }}
                                                    onPress={() => {
                                                        setDistributorActivity(act, true)
                                                        setOpenPicker(false)
                                                    }}
                                                >
                                                    <Text style={styles.subtitle}>{act.title}</Text>
                                                </TouchableOpacity>
                                            ))}
                                        </View>
                                    )}
                                </View>
                            )}
                            {selectedDay.distributor_activities.length > 0 && (
                                <>
                                    <View style={styles.spacer} />

                                    {selectedDay.distributor_activities.map((activity) => (
                                        <View key={activity._id} style={styles.containerRow}>
                                            <YesNoActivityCard activity={activity} updateActivity={updateDistributorActivity} />
                                        </View>
                                    ))}
                                </>
                            )}
                        </>
                    )} */}
                    <View style={styles.spacer}></View>
                    <View style={styles.spacer}></View>
                    <View style={styles.divider}></View>
                    <View style={styles.spacer}></View>
                    <View style={styles.spacer}></View>
                    <Text style={styles.section}>Valida otras actividades: </Text>
                    <View style={styles.spacerMin}></View>
                    <Text style={styles.subSection}>
                        Estas son las actividades que no fueron relacionadas al distribuidor. Puedes eliminar o modificar lo que consideres necesario
                        para ajustar la planificación del día.
                    </Text>
                    <View style={styles.spacer}></View>
                    {selectedDay.monthly_activities
                        .filter((a) => a.status != -1)
                        .map((activity) => (
                            <View style={styles.containerRow} key={activity._id}>
                                <View style={[styles.containerRow, { flex: 1, marginVertical: 6, justifyContent: 'space-between' }]}>
                                    <View style={[styles.containerRow, { flex: 9 }]}>
                                        <Text
                                            style={[
                                                styles.subtitle,
                                                { maxWidth: '80%', textDecorationLine: activity.status === -1 ? 'line-through' : 'none' },
                                            ]}
                                        >
                                            {activity.title}
                                        </Text>
                                    </View>
                                    <View style={styles.containerRow}>
                                        <View style={[styles.label, { marginRight: 12 }]}>
                                            <Ionicons name={'calendar'} size={iconSize} color={'white'} style={styles.paddingRight} />
                                            <Text style={styles.frequency}>{getFreqLabel(activity.frequency ?? '')}</Text>
                                        </View>
                                        <View style={[{ flexDirection: 'row', marginRight: 12 }]}>
                                            <TouchableOpacity style={styles.paddingRight} onPress={() => updateMonthlyActivity(activity, -1)}>
                                                <Ionicons
                                                    name={activity.status === -1 ? 'trash' : 'trash-outline'}
                                                    size={26}
                                                    color={theme.colors.colorDisapproved}
                                                />
                                            </TouchableOpacity>
                                        </View>
                                    </View>
                                </View>
                            </View>
                        ))}
                    <View style={styles.spacer}></View>
                    <TouchableOpacity
                        style={[styles.input, { marginHorizontal: 12 }]}
                        onPress={() => setOpenMonthlyActivities(!openMonthlyActivities)}
                        disabled={selectedDay.status == STATUS_PERIOD.VACATION}
                    >
                        <Text style={styles.subtitle}>Elegir otras actividades</Text>
                        <View style={styles.containerRow}>
                            {/*<Feather name={'search'} size={22} color={theme.colors.colorPrimary} />*/}
                            <Feather name={openOtherActivities ? 'chevron-up' : 'chevron-down'} size={22} color={theme.colors.colorPrimary} />
                        </View>
                    </TouchableOpacity>

                    {openMonthlyActivities && (
                        <View>
                            {filterMonthlyActs.length > 0 && (
                                <View style={[styles.inputDropdownMenuSubsection, styles.marginHorizontal]}>
                                    {filterMonthlyActs.map((act) => (
                                        <TouchableOpacity
                                            key={act._id}
                                            style={{ marginVertical: 8 }}
                                            onPress={() => {
                                                setOtherActivity(act, true)
                                                setOpenMonthlyActivities(false)
                                            }}
                                            disabled={selectedDay.status == STATUS_PERIOD.VACATION}
                                        >
                                            <Text style={styles.option}>{act.title}</Text>
                                        </TouchableOpacity>
                                    ))}
                                </View>
                            )}
                        </View>
                    )}

                    {/* {selectedDay.activities.length > 0 && (
                        <>
                            {selectedDay.activities.map((activity) => (
                                <View
                                    key={activity._id}
                                    style={[styles.containerRow, styles.optionSelected, { justifyContent: 'space-between', marginHorizontal: 12 }]}
                                >
                                    <View style={styles.containerRow}>
                                        <Text style={[styles.option, { marginHorizontal: 12 }]}>{activity.title}</Text>
                                    </View>
                                    <View style={styles.containerRow}>
                                        <View style={[styles.label, { marginRight: 12 }]}>
                                            <Ionicons name={'calendar'} size={12} color={'white'} style={styles.paddingRight} />
                                            <Text style={styles.frequency}>{getFreqLabel(activity.frequency ?? '')}</Text>
                                        </View>

                                        <TouchableOpacity style={styles.marginRight} onPress={() => setOtherActivity(activity, false)}>
                                            <Ionicons name={'trash-outline'} size={24} color={theme.colors.error} />
                                        </TouchableOpacity>
                                    </View>
                                </View>
                            ))}
                        </>
                    )} */}
                </View>
            </View>
        )
    }
}

export const SelectedDistributorCard = ({ distributor, deleteDistributor, activities, setActivity, selectedAct, canDelete }) => {
    const [openDrop, setOpenDrop] = useState(false)
    const [isOpen, setIsOpen] = useState(false)

    const toggleDropdown = () => {
        setIsOpen(!isOpen)
    }

    const fontScale = 1
    const iconSize = 16 * fontScale
    const iconSizeMax = 24 * fontScale
    return (
        <>
            {distributor && distributor.name && (
                <View style={styles.containerRow}>
                    <View style={styles.cardContainer}>
                        {distributor.name && (
                            <View style={[styles.header, { justifyContent: 'space-between' }]}>
                                <View style={[{ flex: 10 }, styles.containerRow]}>
                                    <Feather name='truck' size={iconSize} color={theme.colors.textPrimary} />
                                    <Text style={[styles.headerText, { marginLeft: 12 }]}>{distributor.name}</Text>
                                </View>
                                {canDelete && (
                                    <TouchableOpacity style={{ flex: 1 }} onPress={() => deleteDistributor()}>
                                        <Ionicons name={'trash-outline'} size={iconSizeMax} color={theme.colors.error} />
                                    </TouchableOpacity>
                                )}
                            </View>
                        )}
                        {distributor.code && (
                            <View style={styles.infoContainer}>
                                <Text style={styles.storecode}>{distributor.code}</Text>
                                {distributor.distance && (
                                    <View style={styles.containerData}>
                                        <Text style={styles.separator}> | </Text>
                                        <Feather name='map-pin' size={iconSize} color={theme.colors.textSecondary} />
                                        <Text style={styles.infoText}>{distributor.distance}</Text>
                                    </View>
                                )}
                            </View>
                        )}
                        {distributor.address && <Text style={styles.addressText}>{distributor.address}</Text>}

                        {/* {canDelete && (
                                <>
                                    <TouchableOpacity style={styles.input} onPress={() => setOpenDrop(!openDrop)}>
                                        <Text style={styles.subtitle}>Selecciona una actividad</Text>
                                        <View style={styles.containerRow}>
                                            <Feather name={openDrop ? 'chevron-up' : 'chevron-down'} size={22} color={theme.colors.colorPrimary} />
                                        </View>
                                    </TouchableOpacity>

                                    {openDrop && (
                                        <View>
                                            {activities.length > 0 && (
                                                <View style={styles.inputDropdownMenuSubsection}>
                                                    {activities.map((activities) => (
                                                        <TouchableOpacity
                                                            key={activities._id}
                                                            style={{ marginTop: 16 }}
                                                            onPress={() => {
                                                                setActivity(activities, true)
                                                                setOpenDrop(false)
                                                            }}
                                                        >
                                                            <Text style={styles.subtitle}>{activities.title}</Text>
                                                        </TouchableOpacity>
                                                    ))}
                                                    <View style={{ height: 16 }}></View>
                                                </View>
                                            )}
                                        </View>
                                    )}
                                    {selectedAct.length > 0 && (
                                        <>
                                            {selectedAct.map((activity) => (
                                                <View key={activity._id} style={[styles.containerRow, styles.optionSelected]}>
                                                    <TouchableOpacity style={[styles.paddingHorizontal]} onPress={() => setActivity(activity, false)}>
                                                        <Ionicons name={'close'} size={24} color={theme.colors.error} />
                                                    </TouchableOpacity>

                                                    <Text style={[styles.activity, styles.maxWidth]}>{activity.title}</Text>
                                                </View>
                                            ))}
                                        </>
                                    )}
                                </>
                            )} */}
                    </View>
                </View>
            )}
        </>
    )
}

export const ScheduleCalendar = ({
    week,
    changeWeek,
    currendDayIndex,
    currendWeekIndex,
    changeDay,
    isModerator,
    periodStatus,
    period,
}: {
    week: Week
    changeWeek: (index: number) => void
    currendDayIndex?: number
    currendWeekIndex?: number
    changeDay: (index: number) => void
    isModerator: boolean
    periodStatus: number
    period?: Period
}) => {
    return (
        <View style={{ flex: 0, marginTop: 0 }}>
            <LinearGradient
                style={styles.containerScheduleWeek}
                colors={[theme.colors.linearGradientStart, theme.colors.linearGradientEnd]}
                start={{ x: 0, y: 0 }}
                end={{ x: 1, y: 0 }}
            >
                <View style={{ flexDirection: 'row', justifyContent: 'center' }}>
                    {periodStatus != STATUS_PERIOD.PERIOD_APROBB && !isModerator && (
                        <TouchableOpacity onPress={() => changeWeek(-1)}>
                            <Feather name='chevron-left' size={20} color={'white'} />
                        </TouchableOpacity>
                    )}
                    <Text style={styles.month}>{week.name_week}</Text>
                    {periodStatus != STATUS_PERIOD.PERIOD_APROBB && !isModerator && (
                        <TouchableOpacity onPress={() => changeWeek(1)}>
                            <Feather name='chevron-right' size={20} color={'white'} />
                        </TouchableOpacity>
                    )}
                </View>

                <FlatList
                    data={week.days ?? []}
                    horizontal
                    renderItem={({ item, index }) => {
                        const isSelected = currendDayIndex === index
                        return (
                            <DayItem
                                day={item}
                                isSelected={isSelected}
                                changeDay={() => changeDay(index)}
                                isModerator={isModerator}
                                currendWeekIndex={currendWeekIndex}
                                period={period}
                                index={index}
                            />
                        )
                    }}
                    keyExtractor={(item) => item.date}
                    style={{ alignSelf: 'center' }}
                />
            </LinearGradient>
        </View>
    )
}

export const DayItem = ({
    day,
    isSelected,
    changeDay,
    isModerator,
    currendWeekIndex,
    period,
    index,
}: {
    day: Day
    isSelected: boolean
    changeDay: () => void
    isModerator: boolean
    currendWeekIndex: number
    period: Period
    index: number
}) => {
    const formattedDate = new Date(day.date).toLocaleDateString('es-ES', { timeZone: 'UTC', day: 'numeric' })
    const formattedDay = new Date(day.date)
        .toLocaleDateString('es-ES', {
            timeZone: 'UTC',
            weekday: 'short',
        })
        .slice(0, 3)
        .toUpperCase()

    const formattedDayTwo = new Date(day.date)
        .toLocaleDateString('es-ES', {
            timeZone: 'UTC',
            weekday: 'short',
        })
        .slice(0, 2)
        .toUpperCase()

    let status = day.status ?? 4

    const getColor = (status: number) => {
        switch (status) {
            case STATUS_PERIOD.PENDING_CHANGE_REQUIRED_WEEKS:
                return theme.colors.error
            case STATUS_PERIOD.PENDING_SET_WEEKS:
                return theme.colors.colorPrimary
            case STATUS_PERIOD.PENDING_APPROBB_WEEKS:
                return theme.colors.colorInProgress
            case STATUS_PERIOD.PERIOD_APROBB:
                return theme.colors.colorApproved
            case STATUS_MODERATION.VACATION:
                return theme.colors.textPrimary
            case STATUS_PERIOD.STATUS_DAY_OTHER_MONTH:
                return theme.colors.lightGray
            default:
                return theme.colors.colorPrimary
        }
    }
    const bottomView = (status: number) => {
        let icon = null
        switch (status) {
            case STATUS_PERIOD.PENDING_CHANGE_REQUIRED_WEEKS:
                // icon = isModerator ? 'repeat-outline' : 'close-outline'
                icon = 'repeat-outline'
                break
            case STATUS_PERIOD.PERIOD_APROBB:
                icon = 'checkmark-outline'
                break
            case STATUS_PERIOD.PENDING_APPROBB_WEEKS:
                icon = 'time-outline'
                break
            case STATUS_PERIOD.VACATION:
                icon = 'sunny-outline'
                break

            case STATUS_MODERATION.PENDING:
                icon = 'checkmark-outline'
                break
            case 0:
                icon = 'checkmark-sharp'
                break
            default:
                icon = null
        }

        if (icon) {
            return <Ionicons name={icon} size={24} color={isSelected ? 'white' : getColor(status)} />
        } else {
            return (
                <Text
                    style={[
                        styles.day,
                        {
                            color:
                                (status != STATUS_PERIOD.PENDING_APPROBB_WEEKS || status != STATUS_PERIOD.PENDING_SET_WEEKS) && isSelected
                                    ? 'white'
                                    : 'black',
                        },
                    ]}
                >
                    --
                </Text>
            )
        }
    }

    let statusColor = getColor(status)

    const fontScale = 1
    const iconSize = 18 * fontScale

    return (
        <View style={{ marginTop: 16 }}>
            {isSelected ? (
                <View style={styles.daySelected}>
                    <TouchableOpacity onPress={() => changeDay()}>
                        <Text style={[styles.day, { color: 'white' }]}>{fontScale < 1.2 ? formattedDay : formattedDayTwo}</Text>
                        <View
                            style={[
                                styles.containerDay,
                                { backgroundColor: status == STATUS_PERIOD.PENDING_SET_WEEKS ? theme.colors.colorPrimary : statusColor },
                            ]}
                        >
                            <Text style={[styles.dayNumber, { color: 'white' }]}>{formattedDate}</Text>
                        </View>
                        <View
                            style={[
                                styles.containerDay,
                                { backgroundColor: status == STATUS_PERIOD.PENDING_SET_WEEKS ? theme.colors.colorPrimary : statusColor },
                            ]}
                        >
                            {bottomView(status)}
                            {/* {isComplete ? viewCheckComplete() : bottomView(status)} */}
                        </View>
                    </TouchableOpacity>
                </View>
            ) : (
                <TouchableOpacity onPress={() => changeDay()}>
                    <Text style={styles.day}>{fontScale < 1.2 ? formattedDay : formattedDayTwo}</Text>

                    <View
                        style={[
                            styles.containerDay,
                            { backgroundColor: status == STATUS_PERIOD.PENDING_SET_WEEKS ? theme.colors.colorPrimary : statusColor },
                        ]}
                    >
                        <Text style={[styles.dayNumber, { color: 'white' }]}>{formattedDate}</Text>
                    </View>
                    <View style={[styles.containerDay, { backgroundColor: 'white' }]}>{bottomView(status)}</View>
                    {/* <View style={[styles.containerDay, { backgroundColor: 'white' }]}>
                        {isComplete ? viewCheckComplete() : bottomView(status)}
                    </View> */}
                </TouchableOpacity>
            )}
        </View>
    )
}
export const YesNoActivityCard = ({ activity, updateActivity }) => {
    return (
        <View style={[styles.containerRow, styles.paddingBottom]}>
            <View
                style={[
                    activity.status === 1
                        ? styles.optionSelectedCheck
                        : activity.status === -1
                        ? styles.optionSelectedClose
                        : styles.optionUnselected,
                    styles.containerCard,
                    styles.marginHorizontal,
                ]}
            >
                <View style={[styles.containerRow, styles.spaceBetween]}>
                    <Text style={[styles.activity, styles.marginHorizontal]}>{activity.title}</Text>
                    <View style={{ flexDirection: 'row' }}>
                        {/* <TouchableOpacity style={[styles.marginLeft, styles.paddingRight]} onPress={() => updateActivity(activity, 1)}>
                            <Ionicons
                                name={activity.status === 1 ? 'checkbox-sharp' : 'checkbox-outline'}
                                size={26}
                                color={theme.colors.colorApproved}
                            />
                        </TouchableOpacity> */}
                        <TouchableOpacity style={styles.paddingRight} onPress={() => updateActivity(activity, activity.status != -1 ? -1 : 1)}>
                            <Ionicons name={activity.status === -1 ? 'trash' : 'trash-outline'} size={26} color={theme.colors.colorDisapproved} />
                        </TouchableOpacity>
                    </View>
                </View>
                <View style={{ height: 2 }}></View>
                <View style={[styles.containerRow, { marginHorizontal: 12 }]}>
                    {/* <DistributorCardStatustag status={activity.status} /> */}
                    {/*<TouchableOpacity>
                        <Text style={styles.textButton}>Agregar comentario</Text>
            </TouchableOpacity>*/}
                </View>
            </View>
        </View>
    )
}
